import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { EmployeeTemplate } from '../../../types/EmployeeTemplate';

export const updateEmployeeTemplate = async (uuid: string, formData: EmployeeTemplate) => {
  const response = await CustomAxios.put(`employee_templates/${uuid}`, formData);
  return response.data;
};

interface UseUpdateEmployeeTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUpdateEmployeeTemplate({ uuid, onSuccessCallback }: UseUpdateEmployeeTemplateProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateEmployeeTemplate],
    mutationFn: (formData: EmployeeTemplate) => updateEmployeeTemplate(uuid, formData),
    onSuccess: (data: EmployeeTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTemplates, data.uuid],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as EmployeeTemplate;
        queryClient.setQueryData([queryKeys.allEmployeeTemplates, template.uuid], template);
      }
    },
  });
}
